import styled from 'styled-components';

export const StatusMessageContainer = styled.article`
  display: flex;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 10px;
  
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  
  @media (min-width: 1024px) {
    padding-bottom: 20px;
  }
`;

export const MessageIcon = styled.div`
  width: 55px;
  flex-shrink: 0;
`;

export const MessageDescription = styled.p`
  margin: 0;
  padding: 0;
  
  font-size: 12px;
  line-height: 16px;
  
  b {
    font-weight: 700;
  }
  
  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 18px;
  }
  
  @media (min-width: 1024px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
